const mainUrl  = 'https://portal.nuseirat.ps/';
const apiUrl  = 'https://nuseirat.ps/portal-api/public/api/v1.0/Portal/';
const storageUrl='https://nuseirat.ps/portal-api/public/documents/';
const attachmentsUrl='https://nuseirat.ps/portal-api/public/attachments/';

export default {mainUrl,apiUrl,storageUrl,attachmentsUrl};
